<template>
    <b-dropdown
        v-if="!_isTvView"
        variant="link"
        right
        toggle-class="text-decoration-none"
        no-caret
    >
        <template #button-content>
            <span style="color: black;" class="fas fa-ellipsis-v"></span>
        </template>
        <b-dropdown-item @click="toExternalLink"
            >View Remote {{ title }}</b-dropdown-item
        >
        <b-dropdown-item
            v-if="useNewTreatmentBoard"
            @click="changetoTreatmentView"
            :disabled="disableButton"
            >Switch to
            {{ totreatmentActivityView ? "Timeline" : "Activity" }}
            View</b-dropdown-item
        >
    </b-dropdown>
</template>

<script>
import ScheduleServices from "@/services/schedule";
import CSETTINGS from "@/constants/settings";
import { capitalize } from "lodash";

const TREATMENTBOARD = "Board";

export default {
    name: "removeViewLink",
    props: {
        mod: {
            type: String,
            default: ""
        },
        useNewTreatmentBoard: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            remoteViewLinks: null,
            totreatmentActivityView: false,
            userPrefType: null,
            disableButton: false,
            firstLoad: true
        };
    },
    async mounted() {
        this.remoteViewLinks = await ScheduleServices.getRemoteViewLinks();
    },
    watch: {
        "$store.state.userPreferences.prefs"(value) {
            if (this.firstLoad) {
                let userPref = value?.treatmentBoardViewType?.showOld;
                this.userPrefType = Boolean(userPref);
                this.changetoTreatmentView();
                this.firstLoad = false;
            }
        },
        totreatmentActivityView(val) {
            this.saveTreatmentBoardViewTypePreferences(Number(val));
        }
    },
    computed: {
        title() {
            return this.mod == CSETTINGS.EXTERNAL_VIEW.TREATMENT
                ? TREATMENTBOARD
                : capitalize(this.mod);
        }
    },
    methods: {
        toExternalLink() {
            let origin = window.location.origin;

            // Use window.open() to open a new tab/window
            if (
                this.remoteViewLinks.message.code == 200 &&
                this.mod in this.remoteViewLinks.resource
            ) {
                let path = origin + this.remoteViewLinks.resource[this.mod];
                window.open(path, "_blank");
            } else {
                this._message("Remote view link unavailable", "warning");
            }
        },
        changetoTreatmentView() {
            this.totreatmentActivityView =
                this.userPrefType != null
                    ? this.userPrefType
                    : !this.totreatmentActivityView;
            this.$emit(
                "change-treatment-view",
                this.totreatmentActivityView ? "activity" : "timeline"
            );
            this.userPrefType = null;
        },
        async saveTreatmentBoardViewTypePreferences(value) {
            this.disableButton = true;
            await this.$store
                .dispatch("userPreferences/updatePref", {
                    category: "treatmentBoardViewType",
                    data: { showOld: value }
                })
                .finally(() => {
                    this.disableButton = false;
                });
        }
    }
};
</script>
